import { Field, Item } from '@sitecore-jss/sitecore-jss-nextjs';
import type { ComponentProps } from 'lib/component-props';

export enum SearchType {
  SearchTitleOnly = '0',
  SearchDocumentText = '1',
}

export type GetPolicyDocumentsCallback = (documents: Group[]) => void;
export type GetPolicyDocumentsFunction = (
  searchType: SearchType,
  searchTerm: string,
  callBack: GetPolicyDocumentsCallback
) => void;

export interface PoliciesResponse {
  policies: Document[];
}

export interface GroupsResponse {
  groups: Group[];
}

export interface Group {
  docGroup: string;
  subGroups: SubGroup[];
}

export interface SubGroup {
  subHeaderDescription: string;
  policies: Document[];
}

export interface Document {
  description: string;
  link: string;
}

export interface DocumentDescription {
  title: string;
  effectiveDate: string;
}

export type PolicyDocSearchFields = {
  searchTitle: Field<string>;
  searchTitleOnlyLabel: Field<string>;
  searchDocumentTextLabel: Field<string>;
  searchResetButtonLabel: Field<string>;
  disclaimer: Field<string>;
  searchButtonLabel: Field<string>;
  searchBoxPlaceholderText: Field<string>;
  listLettersHeadingLevel: Item | null;
  groupingTypeHeadingLevel: Item | null;
  noResultsMessage: Field<string>;
  showMockData: Field<boolean>;
};

export type PolicyDocSearchProps = ComponentProps & {
  fields: PolicyDocSearchFields;
};
